import { Request } from '@/classes/Request.ts'

export const exchangeToken = async (): Promise<void> => {
  await new Request().post('/ajax/family/exchange-token')
}
